// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rating-stars[data-v-7ea3d616]{display:-webkit-box;display:-ms-flexbox;display:flex}.rating-stars .star[data-v-7ea3d616]{width:22px;color:#ecd00d;margin-right:5px}", ""]);
// Exports
module.exports = exports;
